module.exports = __webpack_public_path__ + "static/media/skysports.dca02c77.svg";